import React, { ReactNode } from "react";
import { Routes, Route, Outlet } from "react-router-dom";
import { Box } from "@mui/material";

// Community Pages
import CommunityType from "pages/community/Community";
import People from "pages/community/People";
import Addresses from "pages/community/Addresses";
import DiscipleshipPathway from "pages/community/DiscipleshipPathway";

// Layouts
import Navbar_Internal from "components/PageLayouts/PageFrames/navbar_internal";
import Footer_Internal from "components/PageLayouts/PageFrames/footer_internal";
import Organisation from "./Organisation";
import Accounts from "./Accounts";
import Profile from "./Profile";

interface InternalLayoutProps {
  children: ReactNode;
}

const InternalLayout = ({ children }: InternalLayoutProps) => (
  <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
    <Navbar_Internal />
    <Box sx={{ display: "flex", flex: 1, overflow: "hidden" }}>{children}</Box>
    <Footer_Internal />
  </Box>
);

const AccountsLayout = () => (
  <Box sx={{ display: "flex", flex: 1 }}>
    <Outlet />
  </Box>
);


export default function AccountsModule() {
  return (
    <Routes>
      <Route element={<InternalLayout><Outlet /></InternalLayout>}>
        <Route element={<AccountsLayout />}>
          <Route path="/" element={<Accounts />} />
          <Route path="/organisation/" element={<Organisation />} />
          <Route path="/profile/" element={<Profile />} />
        </Route>
      </Route>
    </Routes>
  );
}
